export const SET_FILTER_VALUE = 'SET_FILTER_VALUE';
export const SET_MULTIPLE_VALUES = 'SET_MULTIPLE_VALUES';
export const SET_SMD_FILTER_VALUE = 'SET_SMD_FILTER_VALUE';
